var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 72.6667C35.4097 72.6667 31.2393 71.8178 27.3129 70.1235C23.3696 68.422 19.9344 66.1035 16.9988 63.1679C14.0632 60.2323 11.7447 56.797 10.0432 52.8538C8.34886 48.9273 7.5 44.757 7.5 40.3333C7.5 35.8524 8.34952 31.6545 10.0432 27.7295C11.7444 23.7871 14.0619 20.367 16.9955 17.4604C19.9314 14.5514 23.3677 12.2455 27.3129 10.5432C31.2393 8.84886 35.4097 8 39.8333 8C44.3143 8 48.5122 8.84952 52.4371 10.5432C56.3815 12.2452 59.8026 14.5501 62.7096 17.4571C65.6165 20.3641 67.9215 23.7852 69.6235 27.7295C71.3171 31.6545 72.1667 35.8524 72.1667 40.3333C72.1667 44.757 71.3178 48.9273 69.6235 52.8538C67.9211 56.799 65.6153 60.2353 62.7063 63.1712C59.7996 66.1048 56.3796 68.4223 52.4371 70.1235C48.5122 71.8171 44.3143 72.6667 39.8333 72.6667Z",
    stroke: "#FF6666",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2701 50.1289L39.3401 50.0589C38.092 51.302 36.4022 52 34.6406 52C32.879 52 31.1892 51.302 29.9411 50.0589C28.698 48.8108 28 47.121 28 45.3594C28 43.5978 28.698 41.908 29.9411 40.6599L32.6808 37.9202M40.7299 29.8711L40.6599 29.9411C41.908 28.698 43.5978 28 45.3594 28C47.121 28 48.8108 28.698 50.0589 29.9411C51.302 31.1892 52 32.879 52 34.6406C52 36.4022 51.302 38.092 50.0589 39.3401L47.3192 42.0798M44.8794 51.5987L35.1206 28.4013",
    stroke: "#FF6666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect_icon.2f24b1b87174bff391b9956ec269910e.svg";
export { ForwardRef as ReactComponent };